/* eslint-disable no-else-return */
/* eslint-disable sonarjs/no-redundant-jump */
import { useRouter } from 'next/router'
import { toAlpha2 } from '@/lib/utils/localization/toAlpha2'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SupportedAlpha3CountryCode } from '@/lib/utils/localization/getSupportedAlpha3CountryCodes'
import { isSupportedAlpha2CountryCode } from '@/lib/utils/localization/isSupportedAlpha2CountryCode'
import { externalMarkets } from '@/constants/pickerRegions/externalMarkets'
import useParseLinkUrlWithLocale from './useParseLinkUrlWithLocale'

// TODO: implement more logic or more parameters if needed
const buildExternalURL = (
  alpha2: Alpha2CountryCode,
  params?: { refID?: string },
): string => {
  const externalMarket = externalMarkets[alpha2]
  if (!externalMarket) return ''

  const { baseUrl } = externalMarket
  if (params?.refID && !Number.isNaN(Number(params.refID))) {
    return `${baseUrl}/customers?referralCode=${params.refID}&expand=customer`
  }
  return baseUrl
}

const useClientRedirect = () => {
  const { query, push } = useRouter()
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()

  const clientRedirect = {
    toQueryParams: async () => {
      if (query.redirectTo) {
        await push(
          parseLinkUrlWithLocale({
            url: query.redirectTo as string,
            withQueryString: true,
          }),
        )
      }
    },
    to: async ({
      path,
      withPersistingLocale = true,
      params,
    }: {
      path: string
      withPersistingLocale?: boolean
      params?: {
        refID?: string
      }
    }) => {
      if (withPersistingLocale) {
        await push(parseLinkUrlWithLocale({ url: path }))
        return
      }

      const alpha2 = toAlpha2(path.split('/')[1] as SupportedAlpha3CountryCode)
      const language = path.split('/')[2]
      const fallbackURL = `https://shop.unicity.com/home/loc/${language}-${alpha2}`

      if (alpha2 && !isSupportedAlpha2CountryCode(alpha2)) {
        const externalMarket = externalMarkets[alpha2 as Alpha2CountryCode]

        if (externalMarket) {
          const url = buildExternalURL(alpha2 as Alpha2CountryCode, params)
          await push(url)
          return
        }
        await push(fallbackURL)
      } else {
        await push(path)
        window.location.reload()
      }
    },
  }

  return { clientRedirect, queryParamsRedirect: query.redirectTo }
}

export default useClientRedirect
